import React, { useEffect } from 'react';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { formatPhone } from 'lib/phoneUtil';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';

import useTrialProtectedPageGuard from '../../hooks/useTrialProtectedPageGuard';
import { FakeWrapper } from '../../layout';
import { Subheading } from 'components/Trials/styles';

import EnterCode from './components/EnterCode';

const AccountVerification = () => {
  const { phone } = useTrialsContext() || {};
  useTrialProtectedPageGuard();

  const trackEvent = useTrackAmplitudeEvent();
  useEffect(() => {
    trackEvent('trials.accountVerification.verificationPageViewed');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FakeWrapper title="Confirm your phone number.">
      <Subheading>
        We just sent a verification code to{' '}
        <span style={{ fontWeight: '800' }}>
          {' '}
          {formatPhone(phone, 'NATIONAL')}
        </span>
        . Enter the 4-digit code to continue.
      </Subheading>

      <EnterCode />
    </FakeWrapper>
  );
};

export default AccountVerification;
